import { render } from "./BillingInformation.vue?vue&type=template&id=e0f3a218"
import script from "./BillingInformation.vue?vue&type=script&lang=js"
export * from "./BillingInformation.vue?vue&type=script&lang=js"

import "./BillingInformation.vue?vue&type=style&index=0&id=e0f3a218&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/BillingInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e0f3a218"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e0f3a218', __exports__)) {
    console.log('reload')
    api.reload('e0f3a218', __exports__)
  }
  
  module.hot.accept("./BillingInformation.vue?vue&type=template&id=e0f3a218", () => {
    console.log('re-render')
    api.rerender('e0f3a218', render)
  })

}


export default __exports__